import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { wsGetAll } from 'services/WService';
import Modal from 'components/Tvendo/Common/ModalBase';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

export default function ModalSaleForceDetail(props) {
  const saleForceCanal = props.model;

  const [dataChanging, setDataChanging] = useState(saleForceCanal);

  const [canals, setCanals] = useState([]);
  const [priceLists, setPriceLists] = useState([]);

  async function listCanals() {
    let response = await wsGetAll('base/canal');
    if (response.success) setCanals(response.data);
  }

  async function getPriceList() {
    let response = await wsGetAll('logi/price-list');
    if (response.success) setPriceLists(response.data);
  }

  function handleChange(field, value) {
    setDataChanging({
      ...dataChanging,
      [field]: value
    });
  }

  useEffect(() => {
    if (saleForceCanal.open) {
      listCanals();
      getPriceList();
    }
  }, [saleForceCanal.open]);

  return (
    <Modal
      title="Fuerza de venta canal"
      model={saleForceCanal}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      dataChanging={dataChanging}
      setDataChanging={setDataChanging}
      entity="base/sale-force-canal"
      dataForce={{ base_sale_force_id: props.idSaleForce }}
      state
    >
      <FormControl fullWidth margin="normal" size="small">
        <InputLabel>Canal</InputLabel>
        <Select
          defaultValue={saleForceCanal.base_canal_id || ''}
          inputProps={{
            name: 'base_canal_id'
          }}
        >
          {canals.map((canal, i) => {
            return (
              <MenuItem value={canal.id} key={i}>
                {canal.description}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>

      {priceLists.length > 0 ? (
        <Autocomplete
          options={priceLists}
          getOptionLabel={(option) => option.ListName}
          defaultValue={
            !!saleForceCanal
              ? priceLists.find((priceList) => priceList.id == saleForceCanal.logi_price_list_id)
              : undefined
          }
          renderInput={(params) => (
            <TextField {...params} label="Lista de precios" margin="normal" />
          )}
          onChange={(e, item) => {
            if (!!item) {
              return handleChange('logi_price_list_id', item.id);
            }
            handleChange('logi_price_list_id', null);
          }}
        />
      ) : undefined}
    </Modal>
  );
}
